<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const { containerClass } = defineProps({
  containerClass: {
    type: String,
    required: false,
    default: 'w-full',
  },
});
</script>

<template>
  <div
    class="flex cursor-pointer items-center justify-start gap-3 overflow-hidden rounded-xl bg-white p-4 outline outline-1 outline-offset-[-1px] outline-neutral-300-a hover:bg-steel-100 active:bg-steel-200"
    :class="containerClass"
    @click.stop="
      () =>
        router.push({
          name: 'Capacity',
          query: { modal: 'post-capacity' },
        })
    "
  >
    <div class="relative h-9 w-9 overflow-hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
      >
        <path
          d="M5.0625 6.75C3.5085 6.75 2.25 8.01 2.25 9.5625V20.25H20.25V9.5625C20.25 8.0085 18.99 6.75 17.4375 6.75H5.0625ZM20.25 22.5H2.25V26.4375C2.25 27.99 3.51 29.25 5.0625 29.25H5.625C5.625 28.0565 6.09911 26.9119 6.94302 26.068C7.78693 25.2241 8.93153 24.75 10.125 24.75C11.3185 24.75 12.4631 25.2241 13.307 26.068C14.1509 26.9119 14.625 28.0565 14.625 29.25H19.125C19.4234 29.25 19.7095 29.1315 19.9205 28.9205C20.1315 28.7095 20.25 28.4234 20.25 28.125V22.5Z"
          fill="#6C7C9D"
        />
        <path
          d="M12.375 29.25C12.375 28.6533 12.1379 28.081 11.716 27.659C11.294 27.2371 10.7217 27 10.125 27C9.52826 27 8.95597 27.2371 8.53401 27.659C8.11205 28.081 7.875 28.6533 7.875 29.25C7.875 29.8467 8.11205 30.419 8.53401 30.841C8.95597 31.2629 9.52826 31.5 10.125 31.5C10.7217 31.5 11.294 31.2629 11.716 30.841C12.1379 30.419 12.375 29.8467 12.375 29.25ZM23.625 10.125C23.3266 10.125 23.0405 10.2435 22.8295 10.4545C22.6185 10.6655 22.5 10.9516 22.5 11.25V28.125C22.5 28.2555 22.5225 28.38 22.563 28.497C22.75 27.3887 23.3449 26.3905 24.2307 25.6988C25.1165 25.0071 26.2292 24.6719 27.3497 24.7591C28.4702 24.8464 29.5176 25.3498 30.2856 26.1704C31.0537 26.9909 31.4869 28.0692 31.5 29.193C32.7795 28.9305 33.783 27.7905 33.696 26.3685C33.3604 20.876 31.4133 15.6044 28.098 11.2125C27.8397 10.8729 27.5062 10.5979 27.1235 10.4092C26.7409 10.2205 26.3196 10.1232 25.893 10.125H23.625Z"
          fill="#6C7C9D"
        />
        <path
          d="M29.25 29.25C29.25 28.6533 29.0129 28.081 28.591 27.659C28.169 27.2371 27.5967 27 27 27C26.4033 27 25.831 27.2371 25.409 27.659C24.9871 28.081 24.75 28.6533 24.75 29.25C24.75 29.8467 24.9871 30.419 25.409 30.841C25.831 31.2629 26.4033 31.5 27 31.5C27.5967 31.5 28.169 31.2629 28.591 30.841C29.0129 30.419 29.25 29.8467 29.25 29.25Z"
          fill="#6C7C9D"
        />
      </svg>
    </div>
    <div class="flex flex-1 flex-col items-start gap-1">
      <div class="text-sm font-medium leading-tight tracking-tight">
        Post Capacity
      </div>
      <div class="text-xs font-normal leading-none tracking-tight">
        Post your trucks and get noticed.
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
